import { TRANSLATION_KEYS } from '@/translations/translation-keys';

export const STEPS = {
  SERVICE: 'service',
  TRIP: 'trip',
  CATEGORY: 'category',
  EXTRAS: 'extras',
  OVERVIEW: 'overview',
  PERSONAL: 'personal',
  MBR_TRIP: 'mbr_trip',
  MBR_CATEGORY: 'mbr_category',
  MBR_EXTRAS: 'mbr_extras',
  MBR_OVERVIEW: 'mbr_overview',
};

export const webviewFlow = [STEPS.SERVICE, STEPS.TRIP, STEPS.CATEGORY, STEPS.EXTRAS, STEPS.OVERVIEW];
export const mbRentFlow = [STEPS.SERVICE, STEPS.MBR_TRIP, STEPS.MBR_CATEGORY, STEPS.MBR_EXTRAS, STEPS.MBR_OVERVIEW];
export const websiteFlow = [STEPS.TRIP, STEPS.CATEGORY, STEPS.EXTRAS, STEPS.PERSONAL];

export const STEP_TITLES = {
  [STEPS.TRIP]: TRANSLATION_KEYS.page_title_trip,
  [STEPS.CATEGORY]: TRANSLATION_KEYS.page_title_category,
  [STEPS.EXTRAS]: TRANSLATION_KEYS.page_title_extras,
  [STEPS.PERSONAL]: TRANSLATION_KEYS.page_title_success,
};
